import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { AppRightPanelComponent } from './rightpanel.component';

@NgModule({
    imports: [
        CommonModule,
        AppSharedModule
    ],
    declarations: [
        AppRightPanelComponent
    ],
    exports: [
        AppRightPanelComponent
    ]
})
export class AppRightPanelModule {

}
